module.exports = __webpack_public_path__ + "static/media/bank_statement.960c72bc.svg";